//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import adminSection from '~/mixins/admin-section'
import AdminSectionContent from '~/components/admin-sections/section-content.vue'
import AdminSectionGallery from '~/components/admin-sections/section-gallery.vue'

export default {
  name: 'AdminSectionGalleryWithText',
  components: { AdminSectionGallery, AdminSectionContent },
  mixins: [adminSection],
  data () {
    return {
      contentHeight: '400px',
      fixed: true
    }
  },
  computed: {
    ...mapState({
      breakpoint: 'breakpoint'
    }),
    getSliderSettings: app => (name) => {
      const isSlider = app.$store.state.breakpoint.screen.widthMinCalc <= 1024
      const SETTINGS = {
        'discover-flotilla': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 2,
                  arrows: false
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.updateContentHeight()
      window.addEventListener('resize', this.updateContentHeight)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateContentHeight)
  },
  methods: {
    updateContentHeight () {
      if (this.$refs.content) {
        const contentComputedStyle = window.getComputedStyle(this.$refs.content.$el)
        this.contentHeight = contentComputedStyle.height
      }
      if (this.$refs.body) {
        const containerComputedStyle = window.getComputedStyle(this.$refs.body)
        this.fixed = containerComputedStyle.display !== 'grid'
      }
    }
  }
}
